module.exports = __webpack_public_path__ + "static/media/metehe.cf296789.png";